import { nlBE } from "../../../../date-fns/locale/nl-BE.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    nlBE
  }
};